<template>
  <div class="rt-section">
    <div v-if="hasTitle" class="section-header">
      <div v-if="hasIcon" class="section-icon">
        <rt-icon :name="icon" :size="22" />
      </div>
      <span class="section-title">{{ title }}</span>
      <span v-if="showMore" class="section-more" @click="moreClick">
        <slot name="more">{{ $tx('更多', 'xpc.section.more') }}</slot>
      </span>
      <div class="section-btns"><slot name="btn" /></div>
    </div>
    <div class="section-body"><slot /></div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
export default {
  name: 'RtSection',
  components: {
    RtIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasIcon() {
      return !!this.icon;
    },
    hasTitle() {
      return !!this.title;
    }
  },
  methods: {
    moreClick() {
      this.$emit('more-click');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtSection.vue?50119ca2